<template>
  <div>
    <div class="theme">
      <div class="theme-con">
        <!-- <div class="breadcrumbs section">
          <el-breadcrumb separator-class="el-icon-arrow-right">
            <span style="float:left">当前位置：</span>
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>期刊列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div> -->
        <div class="details">
          <div class="left">
            <left @type="getType" @type2="getType2"></left>
          </div>
          <div class="right">
            <right
              v-loading="!loading"
              :total="total"
              :pageSize="pageSize"
              :list="list"
              :pageNo="pageNo"
              :condition="condition.name"
              :condition2="condition2.name"
              @PN="getPAge"
            ></right>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import left from "./left-con";
import right from "./right-con";
export default {
  created() {
    this.keywords = this.$route.query.main ? this.$route.query.main : "";
    this.load();
  },
  components: {
    left,
    right,
  },
  data() {
    return {
      loading: false,
      condition: { name: "所有系列", id: 0 },
      condition2: { name: "所有学科", id: 0 },
      keywords: "",
      pageNo: 1,
      total: 0,
      pageSize: 18,
      list: [],
    };
  },
  methods: {
    load() {
      // this.loading = false;
      // var reg = /\:/g;
      // var reg1 = /[a-zA-Z]/g;
      // if (!reg.test(this.keywords) && reg1.test(this.keywords)) {
      //   this.keywords = '"' + this.keywords + '"';
      // }
      // var obj = {
      //   pageNo: this.pageNo,
      //   pageSize: this.pageSize,
      //   condition: {
      //     classes: this.condition.id,
      //     keywords: this.keywords,
      //     subjectId: this.condition2.id,
      //   },
      // };
      // console.log(obj);
      // this.$api
      //   .chineseNedicalAssociation(obj)
      //   .then((res) => {
      //     console.log(res);
      //     this.pageSize = res.data.limit;
      //     this.pageNo = res.data.pageNo;
      //     this.total = res.data.total;
      //     this.list = res.data.list ? res.data.list : [];
      //     this.loading = true;
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    //类别
    getType(x) {
      this.condition = x;
      this.pageNo = 1;
      this.load();
    },
    //学科分类
    getType2(x) {
      this.condition2 = x;
      this.pageNo = 1;
      this.load();
    },
    //分页
    getPAge(x) {
      this.pageNo = x;
      this.load();
    },
  },
  watch: {
    $route(news, old) {
      this.keywords = news.query.main;
      this.pageNo = 1;
      this.load();
    },
  },
};
</script>

<style scoped lang="scss">
.section {
  position: relative;
}
.section::before {
  content: "";
  display: block;
  width: 30px;
  height: 1px;
  background-color: #02354b;
  position: absolute;
  left: 0;
  bottom: -1px;
  z-index: 9;
}
.section::after {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background-color: #ddd;
  position: absolute;
  left: 0;
  bottom: -1px;
}
.theme {
  text-align: left;
  min-width: 1200px;
  background-color: #fff;
}
.theme-con {
  margin: 0 80px;
  width: 1200px;
}
.breadcrumbs {
  padding-top: 20px;
  line-height: 60px;
  height: 60px;
}
.breadcrumbs span {
  font-size: 15px;
}
.details > .left {
  // width: 200px;
  // margin-right: 20px;
  // float: left;
}
.details > .right {
  // margin-left: 220px;
  // height: auto;
}
</style>